
(function(){
  if (window.__wlp) return; window.__wlp = true;
  var root = document;
  // videos load only when they come near the screen (each one is megabytes), then play
  var lazy = root.querySelectorAll('video[data-mge-lazy]');
  function wake(v){ if(!v.hasAttribute('data-mge-lazy')) return; v.removeAttribute('data-mge-lazy');
    v.querySelectorAll('source[data-src]').forEach(function(s){ s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
    v.load(); var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
  if('IntersectionObserver' in window){
    var vio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ wake(e.target); vio.unobserve(e.target); } }); }, {rootMargin:'250px 0px'});   // starts a video just before it scrolls into view ("Video head start" setting), so only the first one loads on open
    lazy.forEach(function(v){ vio.observe(v); });
  } else lazy.forEach(wake);
  // video spinner: gone as soon as the video has a frame to show (or starts playing)
  root.querySelectorAll('.mge-vwrap video').forEach(function(v){
    var w = v.parentElement, done = function(){ w.classList.add('is-playing'); };
    if(v.readyState >= 2) done(); else { v.addEventListener('loadeddata', done, {once:true}); v.addEventListener('playing', done, {once:true}); }
  });
  root.querySelectorAll('[data-mge-packs]').forEach(function(box){
    var btn = box.querySelector('.mge-pk-btn');
    function pick(p){
      box.querySelectorAll('.mge-pk').forEach(function(x){ x.classList.remove('active'); x.setAttribute('aria-checked','false'); });
      p.classList.add('active'); p.setAttribute('aria-checked','true'); box.dataset.sel = p.dataset.i;
      btn.querySelector('[data-price]').textContent = p.dataset.price;
      btn.querySelector('[data-compare]').textContent = p.dataset.compare;
      btn.dataset.href = p.dataset.url;
    }
    box.querySelectorAll('.mge-pk').forEach(function(p){
      p.addEventListener('click', function(){ pick(p); });
      p.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(p); } });
    });
    btn.addEventListener('click', function(){ if(btn.dataset.href) window.location.href = btn.dataset.href; });
  });
  root.querySelectorAll('[data-mge-timer]').forEach(function(t){
    var mins = parseInt(t.dataset.mgeTimer,10) || 15, key = t.dataset.key, end;
    try { end = parseInt(localStorage.getItem(key),10); } catch(e){}
    if(!end || end < Date.now()){ end = Date.now() + mins*60000; try { localStorage.setItem(key, end); } catch(e){} }
    var h = t.querySelector('[data-h]'), m = t.querySelector('[data-m]'), s = t.querySelector('[data-s]');
    function pad(n){ return (n<10?'0':'') + n; }
    function tick(){
      var left = end - Date.now();
      if(left <= 0){ end = Date.now() + mins*60000; try { localStorage.setItem(key, end); } catch(e){} left = mins*60000; }
      var sec = Math.floor(left/1000);
      h.textContent = pad(Math.floor(sec/3600)); m.textContent = pad(Math.floor(sec%3600/60)); s.textContent = pad(sec%60);
    }
    tick(); setInterval(tick, 1000);
  });
  var bar = root.querySelector('[data-mge-sticky]');
  if(bar){
    var packs = root.querySelector('[data-mge-packs]');
    function upd(){
      var show = window.scrollY > 600;
      if(packs){ var r = packs.getBoundingClientRect(); if(r.top < window.innerHeight && r.bottom > 0) show = false; }
      bar.classList.toggle('show', show);
    }
    window.addEventListener('scroll', upd, {passive:true}); upd();
  }
})();
